import { platform } from 'constants'
import { TextInput } from 'react-native'
import { StyledProps } from 'styled-components'
import styled from 'styled-components/native'

import { Box } from 'widgets/Box'

import { ThemeColor } from 'utils/themes/types'

type Props = StyledProps<{
  placeholder?: string
  name?: string
  type?: string
  error?: boolean
  editable?: boolean
  touched?: boolean
  cursor?: string
  disabled?: boolean
  backgroundColor?: ThemeColor
  style?: any
  focused?: boolean
  icon?: string
}>

export const StyledTextInput = styled(TextInput)<Props>`
  ${platform.IS_WEB && 'outline-width: 0px'}
  font-weight: ${({ theme }) => theme.fonts.weights.medium};
  padding: ${({ theme }) => `${theme.spacing.md}px ${theme.spacing.md}px`};
  border-radius: ${({ theme }) => theme.borderRadius.xs}px;
  ${({ icon }) =>
    icon &&
    `
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
`}
  ${platform.IS_WEB && `cursor: ${({ cursor }) => cursor || null}`}

  ${({ theme, disabled, backgroundColor }) =>
    `background-color: ${
      // eslint-disable-next-line no-nested-ternary
      backgroundColor
        ? theme.colors[backgroundColor]
        : disabled
        ? theme.colors.greyLight
        : theme.colors.white
    };`}
  ${({ theme, error }) => (error ? `border: 1px solid ${theme.colors.error};` : null)}

  ${({ icon }) =>
    icon &&
    `
    border-left-width: 0px;
  `}

  color: ${({ theme }) => theme.colors.white};
`

type ContainerProps = StyledProps<{
  focused?: boolean
}>

export const StyledIconContainer = styled(Box)<ContainerProps>`
  width: 50px;
  background-color: ${({ theme }) => theme.colors.greyLight};
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border: 2px solid;
  border-color: ${({ focused, theme }) => (focused ? theme.colors.text : theme.colors.grey)};
`
